var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backHome}},[_vm._v("返回首页")]),_c('Button',{attrs:{"size":"large","type":"text"},on:{"click":_vm.backPrev}},[_vm._v("返回上一页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }